module.exports = __webpack_public_path__ + "img/trainer-snip1.4c18ec08.jpg";